import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
export const SuggestionContextApi = createContext(undefined);
export const SuggestionContext = createContext({
    getProviders: () => [],
});
export const SuggestionRegistryProvider = ({ children }) => {
    const [providers, setProviders] = useState([]);
    const registerProvider = useCallback((provider) => {
        setProviders((prevProviders) => {
            if (prevProviders.some((p) => p.id === provider.id)) {
                console.warn(`Suggestion provider with ID "${provider.id}" already registered.`);
                return prevProviders;
            }
            return [...prevProviders, provider];
        });
    }, []);
    const unregisterProvider = useCallback((id) => {
        setProviders((prevProviders) => prevProviders.filter((p) => p.id !== id));
    }, []);
    const getProviders = useCallback((propertyName, schema) => {
        if (!schema)
            return providers;
        return providers.filter((provider) => provider.appliesTo(propertyName, schema));
    }, [providers]);
    const contextApi = useMemo(() => ({
        registerProvider,
        unregisterProvider,
    }), [registerProvider, unregisterProvider]);
    return (_jsx(SuggestionContextApi.Provider, { value: contextApi, children: _jsx(SuggestionContext.Provider, { value: { getProviders }, children: children }) }));
};
export const useSuggestionRegistry = () => {
    const context = useContext(SuggestionContextApi);
    if (context === undefined) {
        throw new Error('useSuggestionRegistry must be used within a SuggestionRegistryProvider');
    }
    return context;
};
//# sourceMappingURL=SuggestionRegistryProvider.js.map